<template>
	<div>
		<div class="form-title" style="margin-bottom: 10px">Đăng ký</div>

		<form class="main-form" @submit.prevent="submitForm">
			<div class="input-wrapper" style="position: relative">
				<label for="fullname">Nhập họ tên đầy đủ</label>
				<input v-model="form.fullname" type="text" id="fullname" placeholder="Nhập Họ Và Tên"
					style="padding-right: 50px" maxlength="150" @keyup="validateField('fullname')" @copy.prevent
					@paste.prevent />
				<small class="warning" v-if="errors.fullname">
					<img src="@/assets/images/warning.png" alt="" />{{ errors.fullname }}
				</small>
			</div>

			<div class="input-wrapper" style="position: relative">
				<label for="birthday">Ngày sinh</label>
				<input v-model="form.birthday" type="date" id="birthday" @copy.prevent
					@paste.prevent />
				<small class="warning" v-if="errors.birthday">
					<img src="@/assets/images/warning.png" alt="" />{{ errors.birthday }}
				</small>
			</div>

			<div class="input-wrapper" style="position: relative">
				<label for="gender">Giới tính</label>
				<select v-model="form.gender" id="gender" @keyup="validateField('gender')">
					<option value="0">Nữ</option>
					<option value="1">Nam</option>
					<option value="2">Khác</option>
				</select>
				<small class="warning" v-if="errors.gender">
					<img src="@/assets/images/warning.png" alt="" />{{ errors.gender }}
				</small>
			</div>
		</form>

		<a href="javascript:void(0)" :class="{ blur: disableBtnNext }" v-on="disableBtnNext ? {} : { click: submitForm }"
			class="btn-next cursor-pointer" style="margin-bottom: 40px">Tiếp theo</a>

		<a href="javascript:void(0)" class="btn-back" style="margin-bottom: 100px" @click="
			$router.push({
				name: 'regusername',
				params: {},
			})
			">
			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
				<path
					d="M6.72488 10.4525L13.6911 17.09C13.8074 17.2008 13.9618 17.2626 14.1224 17.2626C14.283 17.2626 14.4374 17.2008 14.5536 17.09L14.5611 17.0825C14.6177 17.0287 14.6627 16.9641 14.6935 16.8924C14.7242 16.8207 14.7401 16.7436 14.7401 16.6656C14.7401 16.5876 14.7242 16.5104 14.6935 16.4387C14.6627 16.3671 14.6177 16.3024 14.5611 16.2487L8.00113 9.9987L14.5611 3.7512C14.6177 3.69749 14.6627 3.63283 14.6935 3.56116C14.7242 3.4895 14.7401 3.41232 14.7401 3.33433C14.7401 3.25634 14.7242 3.17916 14.6935 3.10749C14.6627 3.03583 14.6177 2.97117 14.5611 2.91745L14.5536 2.90995C14.4374 2.79915 14.283 2.73733 14.1224 2.73733C13.9618 2.73733 13.8074 2.79915 13.6911 2.90995L6.72488 9.54745C6.66362 9.60582 6.61484 9.67603 6.58152 9.75381C6.54819 9.83159 6.53101 9.91533 6.53101 9.99995C6.53101 10.0846 6.54819 10.1683 6.58152 10.2461C6.61484 10.3239 6.66362 10.3941 6.72488 10.4525Z"
					fill="#0355CE" />
			</svg>
			Quay lại
		</a>
	</div>
</template>
<script>
import { useRegStore } from "@/store";
export default {
	data() {
		const regStore = useRegStore();
		return {
			regStore,
			form: {
				fullname: "",
				birthday: '1990-10-30',
				gender: 0,
			},
			errors: {},
			rules: {
				fullname: [
					(value) => (value == '' || value == null || value == undefined ? "Vui lòng nhập Họ và Tên" : null)
				],
				birthday: [
					(value) => (value == '' || value == null || value == undefined ? "Vui lòng nhập Ngày Sinh" : null)
				]
			},
			disableBtnNext: true,
		};
	},
	methods: {
		submitForm() {
			Object.keys(this.rules).forEach((field) => this.validateField(field));
			if (this.disableBtnNext) {
				return;
			}
			//Validate ở đây
			const regStore = useRegStore();
			regStore.fullname = this.form.fullname;
			regStore.birthday = this.form.birthday;
			regStore.gender = this.form.gender;
			this.$router.push({
				name: "regpassword",
				params: {},
			});
			return;
		},
		validateField(field) {
			const fieldRules = this.rules[field];
			if (fieldRules) {
				for (const rule of fieldRules) {
					const error = rule(this.form[field]);
					if (error) {
						this.errors[field] = error;
						this.validateForm();
						return;
					}
				}
				this.errors[field] = null; // Nếu không có lỗi
			}
			this.validateForm();
		},
		validateForm() {
			// Kiểm tra nếu không có lỗi thì submit form
			if (!Object.values(this.errors).some((error) => error)) {
				this.disableBtnNext = false;
			}
			else{
				this.disableBtnNext = true;
			}
		},
	},
};
</script>
<style>
.main-form select {
  width: 100%;
  height: 55px;
  border-radius: 5px;
  background: #f1f1f1;
  outline: none;
  border: none;
  border-left: 7px solid #2b92fa;
  padding: 15px;
  color: var(--red, #000);

  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px; /* 150% */
  margin-bottom: 20px;
}
.main-form select:focus {
  border-top: solid 1px #2b92fa;
  border-bottom: solid 1px #2b92fa;
  border-right: solid 1px #2b92fa;
}
</style>